import { render, staticRenderFns } from "./StudentInfo.vue?vue&type=template&id=e2d26140&scoped=true"
import script from "./StudentInfo.vue?vue&type=script&lang=js"
export * from "./StudentInfo.vue?vue&type=script&lang=js"
import style0 from "./StudentInfo.vue?vue&type=style&index=0&id=e2d26140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d26140",
  null
  
)

export default component.exports